import { setInitialState } from "../../../utils/reducerOperations";
export function Default() {
    return {
        storyboardPositiveAndNegativeData: {
            isProcessing: false,
            data: {},
            message: null,
            error: false,
        },
    };
}
